/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Secure command to add a borrower product to cart. Contains only IDs - pricing is rebuilt server-side from MNCAP data.
 * @export
 * @interface AddBorrowerToCartSecureCommand
 */
export interface AddBorrowerToCartSecureCommand {
    /**
     * Hash of the selected ContractFunnel. This hash is the one received in the SignalR notification (newHash after pricing). Identifies precisely the ContractFunnel selected by the user.
     * @type {string}
     * @memberof AddBorrowerToCartSecureCommand
     */
    contractFunnelHash: string;
    /**
     * ID of the selected funnel (product)
     * @type {string}
     * @memberof AddBorrowerToCartSecureCommand
     */
    funnelId: string;
    /**
     * ID of the borrower project
     * @type {string}
     * @memberof AddBorrowerToCartSecureCommand
     */
    borrowerProjectId: string;
    /**
     * List of borrower IDs to include in cart. 1 borrower = individual offer, 2 borrowers = group offer
     * @type {Array<string>}
     * @memberof AddBorrowerToCartSecureCommand
     */
    borrowerIds: Array<string>;
    /**
     * Indicates if this is an EXTERNAL group offer (true) or individual (false)
     * @type {boolean}
     * @memberof AddBorrowerToCartSecureCommand
     */
    isGroup: boolean;
    /**
     * Group contract identifier (e.g. "GROUPE_xxx" for framework contracts). Only used for group offers.
     * @type {string}
     * @memberof AddBorrowerToCartSecureCommand
     */
    groupContractId?: string | null;
}

/**
 * Check if a given object implements the AddBorrowerToCartSecureCommand interface.
 */
export function instanceOfAddBorrowerToCartSecureCommand(value: object): value is AddBorrowerToCartSecureCommand {
    if (!('contractFunnelHash' in value) || value['contractFunnelHash'] === undefined) return false;
    if (!('funnelId' in value) || value['funnelId'] === undefined) return false;
    if (!('borrowerProjectId' in value) || value['borrowerProjectId'] === undefined) return false;
    if (!('borrowerIds' in value) || value['borrowerIds'] === undefined) return false;
    if (!('isGroup' in value) || value['isGroup'] === undefined) return false;
    return true;
}

export function AddBorrowerToCartSecureCommandFromJSON(json: any): AddBorrowerToCartSecureCommand {
    return AddBorrowerToCartSecureCommandFromJSONTyped(json, false);
}

export function AddBorrowerToCartSecureCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddBorrowerToCartSecureCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'contractFunnelHash': json['contractFunnelHash'],
        'funnelId': json['funnelId'],
        'borrowerProjectId': json['borrowerProjectId'],
        'borrowerIds': json['borrowerIds'],
        'isGroup': json['isGroup'],
        'groupContractId': json['groupContractId'] == null ? undefined : json['groupContractId'],
    };
}

export function AddBorrowerToCartSecureCommandToJSON(json: any): AddBorrowerToCartSecureCommand {
    return AddBorrowerToCartSecureCommandToJSONTyped(json, false);
}

export function AddBorrowerToCartSecureCommandToJSONTyped(value?: AddBorrowerToCartSecureCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractFunnelHash': value['contractFunnelHash'],
        'funnelId': value['funnelId'],
        'borrowerProjectId': value['borrowerProjectId'],
        'borrowerIds': value['borrowerIds'],
        'isGroup': value['isGroup'],
        'groupContractId': value['groupContractId'],
    };
}

